import styled from '@emotion/styled';

export const TileContainer = styled.div<{ width: number; height: number; isLoading?: boolean }>`
    position: relative;
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    border-radius: 8px;
    overflow: hidden;
    cursor: ${props => (props.isLoading ? 'default' : 'pointer')};

    :hover {
        outline: 2px solid ${({ theme }) => theme.colors.primary.main};
        outline-offset: -2px;

        .only-hover {
            visibility: ${props => (props.isLoading ? 'hidden' : 'visible')};
        }

        :before {
            content: '';
            width: 100%;
            height: 20%;
            opacity: 0.4;
            background: linear-gradient(180deg, rgba(9, 6, 4, 0.7) 0%, rgba(9, 6, 4, 0) 100%);
            position: absolute;
            z-index: 5;
        }
    }
`;
